var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8203 1.96875C10.4862 1.96875 9.30219 2.52633 8.5 3.48469C7.69781 2.52633 6.51379 1.96875 5.17969 1.96875C4.01772 1.97024 2.90376 2.45964 2.08212 3.3296C1.26049 4.19957 0.798281 5.37906 0.796875 6.60938C0.796875 11.6958 7.82332 15.7598 8.12215 15.9307C8.23827 15.9969 8.36811 16.0316 8.5 16.0316C8.63189 16.0316 8.76173 15.9969 8.87785 15.9307C9.17668 15.7598 16.2031 11.6958 16.2031 6.60938C16.2017 5.37906 15.7395 4.19957 14.9179 3.3296C14.0962 2.45964 12.9823 1.97024 11.8203 1.96875ZM11.4557 11.9784C10.5309 12.8094 9.54221 13.5573 8.5 14.2144C7.45779 13.5573 6.46912 12.8094 5.54426 11.9784C4.10523 10.6713 2.39062 8.67797 2.39062 6.60938C2.39062 5.82616 2.68447 5.07502 3.20752 4.5212C3.73057 3.96738 4.43998 3.65625 5.17969 3.65625C6.36172 3.65625 7.35117 4.31719 7.76223 5.38172C7.82205 5.5369 7.92418 5.6697 8.05558 5.76318C8.18698 5.85667 8.3417 5.90659 8.5 5.90659C8.6583 5.90659 8.81302 5.85667 8.94442 5.76318C9.07582 5.6697 9.17795 5.5369 9.23777 5.38172C9.64883 4.31719 10.6383 3.65625 11.8203 3.65625C12.56 3.65625 13.2694 3.96738 13.7925 4.5212C14.3155 5.07502 14.6094 5.82616 14.6094 6.60938C14.6094 8.67797 12.8948 10.6713 11.4557 11.9784Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.6589d78b869bec764aa55b1dda574beb.svg";
export { ForwardRef as ReactComponent };